/***************************************************************************************************
 * Load `$localize` onto the global scope - used if i18n tags appear in Angular templates.
 */
import 'zone.js';
import '@angular/localize/init';
// Used for reflect-metadata in JIT. If you use AOT (and only Angular decorators), you can remove.
import 'reflect-metadata';
